import hasActiveContracts from '@/mixins/hasActiveContracts'

import { ManagerGQL } from '@/graphql/queries'

export default {
  mixins: [hasActiveContracts],

  apollo: {
    accessList: {
      query: ManagerGQL,
      update: data => data.merchant.manager.partnerAccessList,
      skip () { return !this.hasActiveContracts }
    }
  },

  computed: {
    /**
     *
     * @returns {{
     *   ORDER_LIST: string,
     *   BILLS: string,
     *   USERS: string,
     *   MANAGERS: string
     * }|{}}
     */
    myAccess () {
      if (!this.accessList) {
        return {}
      }

      const out = {}
      this.accessList.forEach(r => {
        out[r.role] = r.access
      })

      return out
    }
  }
}
